import { render } from "./ObjectCopyTarget.vue?vue&type=template&id=62d8b8b6"
import script from "./ObjectCopyTarget.vue?vue&type=script&lang=js"
export * from "./ObjectCopyTarget.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.12.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__